// extracted by mini-css-extract-plugin
export var footerWrap = "footer-module--footer-wrap--PgkXu";
export var lrContent = "footer-module--lr-content--tBLRq";
export var social = "footer-module--social--d+veL";
export var copyrightwrap = "footer-module--copyrightwrap--KUZey";
export var copyright = "footer-module--copyright--aObl1";
export var menuLinks = "footer-module--menuLinks--W1VBx";
export var ass_flat = "footer-module--ass_flat--UOdVz";